export default {
  es: {},
};
